<template>
  <div class="staff-subscription-page" data-testid="staff-subscription-page">
    <page-header
      :title="t('Planos de assinaturas')"
      icon="pi pi-id-card"
    />

    <div class="toolbar" data-testid="staff-subscription-toolbar">
      <Button
        :label="t('Criar plano')"
        icon="pi pi-plus"
        severity="primary"
        data-testid="staff-subscription-plan-create-btn"
        @click="openPlanModal()"
      />
      <!-- D3: reveals retired (active=0) plans so they can be reactivated -->
      <input-toggle
        v-model="showInactive"
        elem-id="staff-subscription-show-inactive"
        :label="t('Mostrar inativos')"
        data-testid="staff-subscription-show-inactive"
      />
    </div>

    <staff-subscription-table ref="tableRef" :show-inactive="showInactive" />
    <!-- Modals are registered globally in ModalManager.vue — no local instances here -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import { log } from '../../../utils/DebugLogger'
import PageHeader from '../../../ui/PageHeader.vue'
import StaffSubscriptionTable from './StaffSubscriptionTable.vue'

interface TableExposed {
  loadData: () => Promise<void>
}

const { t } = useI18n()
const tableRef = ref<TableExposed | null>(null)
const showInactive = ref(false)

function openPlanModal(): void {
  // The modal re-lists after a save and cannot read this toggle (it is
  // registered globally in ModalManager), so the breadth goes with the open.
  eventBus.emit('modal.staffSubscriptionPlan.open', { includeInactive: showInactive.value })
}

onMounted(async () => {
  try {
    await tableRef.value?.loadData()
  } catch (err) {
    log('StaffSubscriptionPage', 'onMounted', 'Erro ao carregar planos', err)
  }
})
</script>

<style scoped>
.staff-subscription-page {
  padding: 24px;
}

.toolbar {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
</style>
